import React from 'react';
import AreaNegocioCursoManager from './AreaNegocioCursoManager';

export default function AsignarCursosAreaModal({ open, area, onClose }) {
    if (!open || !area) return null;

    return (
        <div
            className="roles-confirm-overlay"
            role="dialog"
            aria-modal="true"
            onClick={(e) => { if (e.target === e.currentTarget) onClose?.(); }}
        >
            <div
                className="roles-confirm-card"
                style={{
                    width: 'min(1100px, 98vw)',
                    height: 'min(800px, 90vh)',
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                    padding: '24px'
                }}
            >
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '15px',
                    borderBottom: '1px solid #eee',
                    paddingBottom: '10px'
                }}>
                    <h2 className="roles-title" style={{ margin: 0 }}>
                        Cursos para: <span style={{ color: 'var(--primary-color, #1e293b)' }}>{area.nombre}</span>
                    </h2>
                    <button
                        onClick={onClose}
                        style={{
                            background: 'none',
                            border: 'none',
                            fontSize: '1.5rem',
                            cursor: 'pointer',
                            color: '#64748b'
                        }}
                    >
                        ✕
                    </button>
                </div>

                <div style={{ flex: 1, overflowY: 'auto' }}>
                    <AreaNegocioCursoManager
                        idAreaNegocio={area.idAreaNegocio}
                        onClose={onClose}
                    />
                </div>
            </div>
        </div>
    );
}
